module.exports = __webpack_public_path__ + "media/images/driving_school/question_series-e6202e902f43f60ff88c4e693986a3bc.png";